import { AllDeeplinksPlugin } from "../plugin/AllDeeplinksPlugin";

export class AllDeeplinksUseCase {
  constructor(private readonly allDeeplinksPlugin: AllDeeplinksPlugin) {}

  getDeeplinks(): string[] {
    return this.allDeeplinksPlugin.getDeeplinks();
  }

  saveDeeplink(link: string): void {
    if (link.trim().length === 0) {
      return;
    }

    const links = [link, ...this.allDeeplinksPlugin.getDeeplinks()];
    const newLinks = [...new Set(links)];
    const firstTenLinks = newLinks.slice(0, 10);

    this.allDeeplinksPlugin.setDeeplinks(firstTenLinks);
  }

  clearDeeplinks(): void {
    this.allDeeplinksPlugin.setDeeplinks([]);
  }
}
